import { apiEndPoint } from "./endPoint";

export const createNewAssistant = async (
  token: string,
  {
    assistant_name,
    assistant_instructions,
  }: { assistant_name: string; assistant_instructions: string }
) => {
  const url = `${apiEndPoint}/createAssistant`;

  const queryData = {
    name: assistant_name,
    description: "",
    instructions: assistant_instructions,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(queryData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生しました。",
    };
  }
};
